/**
 * @author Kelnik
 *
 * FilterMap - карта в параметрическом
 */
import Observer from 'common/scripts/mediator';
import tmplPanel from '../map-panel/map-panel.twig';
import Utils from 'common/scripts/utils';

const observer = new Observer();
// eslint-disable-next-line no-undef
const Mapboxgl = window.mapboxgl;

class ParametricPopupMap {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-parametric-map-popup';
        this.container = options.wrapper ? options.wrapper.querySelector(this.containerSelector) : null;

        this.openSelector = '.j-parametric-map-popup-open';
        this.closeSelector = '.j-parametric-map-popup-close';
        this.paramsLinkSelector = '.j-parametric-map-popup-params';
        this.complexLinkSelector = '.j-parametric-map-popup-complex';
        this.zoomInSelector = '.j-parametric-map-popup-zoom-in';
        this.zoomOutSelector = '.j-parametric-map-popup-zoom-out';
        this.panelSelector = '.j-parametric-map-popup-panel';

        this.markers = [];

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._bindEvents();
        this._initMap();
    }

    _initElements() {
        this.opens = Array.from(document.querySelectorAll(this.openSelector));
        this.close = this.container.querySelector(this.closeSelector);
        this.paramsLink = this.container.querySelector(this.paramsLinkSelector);
        this.complexLink = this.container.querySelector(this.complexLinkSelector);
        this.zoomIn = this.container.querySelector(this.zoomInSelector);
        this.zoomOut = this.container.querySelector(this.zoomOutSelector);
        this.panel = this.container.querySelector(this.panelSelector);
    }

    _initMap() {
        if (!Mapboxgl) {
            return;
        }

        Mapboxgl.accessToken = this.options.accessToken;

        this.map = new Mapboxgl.Map({
            container: 'parametric-popup-map',
            style    : this.options.style || 'mapbox://styles/mapbox/streets-v11',
            center   : this.options.center || {
                lon: 0,
                lat: 0
            },
            zoom   : this.options.zoom || 3,
            minZoom: this.options.minZoom || 10,
            maxZoom: this.options.maxZoom || 16
        });
    }

    removeMarkers() {
        this.markers.forEach((marker) => {
            marker.remove();
        });
    }

    addMarkersInMap(markers) {
        if (!markers || !markers.length) {
            return;
        }

        this.markersObject = markers;

        markers.forEach((marker) => {
            const elem = document.createElement('div');

            elem.classList.add('parametric-map__marker', 'j-parametric-marker');
            elem.setAttribute('data-id', marker.id);
            elem.style.backgroundImage = `url(${marker.img})`;

            this._addClickMarker(elem);

            this.markers.push(new Mapboxgl.Marker(elem)
                .setLngLat(marker.coords)
                .addTo(this.map));
        });
    }

    _addClickMarker(element) {
        element.addEventListener('click', () => {
            const id = element.dataset.id;
            const {data} = this.markersObject.find((marker) => {
                return Number(marker.id) === Number(id);
            });

            if (element.classList.contains('is-active')) {
                this.activeOnlyMarker();
                this.hidePanel(data);
            } else {
                this.activeOnlyMarker(id);
                this.showPanel(data);
            }
        });
    }

    activeOnlyMarker(id = -1) {
        this.markers.forEach((marker) => {
            const markerEl = marker.getElement();

            if (Number(markerEl.dataset.id) === Number(id)) {
                markerEl.classList.add('is-active');
            } else {
                markerEl.classList.remove('is-active');
            }
        });
    }

    fitBounds() {
        const bounds = new Mapboxgl.LngLatBounds();

        this.markersObject.forEach((marker) => {
            bounds.extend(marker.coords);
        });

        this.map.fitBounds(bounds, {padding: 30});
    }

    showPanel(data) {
        Utils.clearHtml(this.panel);
        this.panel.insertAdjacentHTML('beforeend', tmplPanel(data));
        Utils.show(this.panel);
    }

    hidePanel() {
        Utils.clearHtml(this.panel);
        Utils.hide(this.panel);
    }

    _bindEvents() {
        if (this.close) {
            this.close.addEventListener('click', (event) => {
                event.preventDefault();

                this.toClose();
            });
        }


        if (this.opens) {
            this.opens.forEach((open) => {
                open.addEventListener('click', this.toOpen.bind(this));
            });
        }

        if (this.paramsLink) {
            this.paramsLink.addEventListener('click', () => {
                if (this.options.clickLinkParams) {
                    this.options.clickLinkParams();
                }
            });
        }

        if (this.complexLink) {
            this.complexLink.addEventListener('click', (event) => {
                event.preventDefault();

                if (this.options.clickLinkComplex) {
                    this.toClose();
                    this.options.clickLinkComplex();
                }
            });
        }

        this.zoomIn.addEventListener('click', () => {
            if (this.map) {
                this.map.zoomIn();
            }
        });

        this.zoomOut.addEventListener('click', () => {
            if (this.map) {
                this.map.zoomOut();
            }
        });

        window.addEventListener('resize', Utils.debounce(this._checkVisible.bind(this), 100));
        observer.subscribe('filter-popup:changeCountFilter', (count) => {
            if (count) {
                this.addParamWithMark();
            } else {
                this.removeParamWithMark();
            }
        });
    }

    _checkVisible() {
        if (!this.isOpen()) {
            return;
        }

        if (window.innerWidth >= 960) {
            this.toClose();
        }
    }

    isOpen() {
        return this.container.style.display !== 'none';
    }

    toOpen() {
        Utils.show(this.container, 'flex');
        Utils.bodyFixed(this.container);

        setTimeout(() => {
            if (this.map) {
                this.map.resize();
            }
        }, 0);
    }

    toClose() {
        Utils.hide(this.container);
        Utils.bodyStatic();
    }

    addParamWithMark() {
        this.paramsLink.classList.add('with-mark');
    }

    removeParamWithMark() {
        this.paramsLink.classList.remove('with-mark');
    }
}

export default ParametricPopupMap;
